import { OjWebElement } from '@oracle/oraclejet-webdriver/elements';

/**
 * This is the base class for oj-c-drawer-popup WebElement, and is generated from the
 * component's metadata. Do not modify these contents since they'll be replaced
 * during the next generation.
 * Put overrides into the WebElements's subclass, DrawerPopupWebElement.ts.
 */
export class DrawerPopupWebElementBase extends OjWebElement {
  /**
   * Sets the value of <code>opened</code> property.
   * Specifies whether the Drawer is open.
   * @param opened The value to set for <code>opened</code>
   *
   */
  public changeOpened(opened: boolean): Promise<void> {
    return this.setProperty<boolean>('opened', opened);
  }

  /**
   * Gets the value of <code>opened</code> property.
   * Specifies whether the Drawer is open.
   * @return The value of <code>opened</code> property.
   *
   */
  public getOpened(): Promise<boolean> {
    return this.getProperty<boolean>('opened');
  }

  /**
   * Gets the value of <code>modality</code> property.
   * Controls the modality of the drawer.
   * @return The value of <code>modality</code> property.
   *
   */
  public getModality(): Promise<string> {
    return this.getProperty<string>('modality');
  }

  /**
   * Gets the value of <code>edge</code> property.
   * Specifies at what edge the drawer opens.
   * @return The value of <code>edge</code> property.
   *
   */
  public getEdge(): Promise<string> {
    return this.getProperty<string>('edge');
  }

  /**
   * Gets the value of <code>autoDismiss</code> property.
   * Specifies the close auto-dismiss behaviour to close the drawer.
   * @return The value of <code>autoDismiss</code> property.
   *
   */
  public getAutoDismiss(): Promise<string> {
    return this.getProperty<string>('autoDismiss');
  }

  /**
   * Gets the value of <code>closeGesture</code> property.
   * Specifies whether a gesture closes the drawer.
   * @return The value of <code>closeGesture</code> property.
   *
   */
  public getCloseGesture(): Promise<string> {
    return this.getProperty<string>('closeGesture');
  }

  /**
   * Gets the value of <code>backgroundColor</code> property.
   * Specifies background color of the Drawer.
   * @return The value of <code>backgroundColor</code> property.
   *
   */
  public getBackgroundColor(): Promise<string> {
    return this.getProperty<string>('backgroundColor');
  }
}
